import {
	TablePage,
	ViewPage,
	EditPage,
	AddPage
} from 'src/views/ping-admin/event-code-mapping'
import pathMap from 'src/paths/PathMap_Ping'

class PingEventCodeMappingRoute {
	getConfigurations() {
		return [
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_MAPPING_LIST_VIEW,
				component: TablePage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_MAPPING_DETAILS_VIEW,
				component: ViewPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_MAPPING_EDIT_VIEW,
				component: EditPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_MAPPING_ADD_VIEW,
				component: AddPage
			}
		]
	}
}

export default PingEventCodeMappingRoute
